import z from 'zod';

export function breakFQDN(fqdn: string) {
  const schemeAndDomainWithPort = fqdn.split('://');

  const scheme = z.enum(['http', 'https']).parse(schemeAndDomainWithPort.at(0));

  const domainWithInnerPort = z
    .string()
    .min(1)
    .parse(schemeAndDomainWithPort.at(1));

  const domainAndInnerPort = domainWithInnerPort.split(':');

  const domain = z.string().min(1).parse(domainAndInnerPort.at(0));

  const innerPort = z.coerce.number().parse(domainAndInnerPort.at(1));

  const outerPort =
    domain === 'localhost' ? innerPort : scheme === 'http' ? 80 : 443;

  return {
    scheme,
    domain,
    innerPort,
    outerPort,
  };
}
